'use client';

import { useState, useEffect } from 'react';

export function useCountUp(target: number, duration = 400): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!target || target === 0) { setCount(0); return; }
    const start = performance.now();
    let raf: number;
    const animate = (now: number) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      // Ease out
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(eased * target));
      if (progress < 1) raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  return count;
}
